import { ISurveyData } from '~api/SurveyApiSdk';

export const VTO_SURVEY_DISCLAIMER = 'vto-survey-overlay-disclaimer';
export const VTO_SURVEY_QUESTION1_TITLE = 'vto-survey-question1-title';
export const VTO_SURVEY_END_MESSAGE = 'vto-survey-end-message';
// generated the array of numbers from 0 to 10
export const SURVEY_BUTTONS_DATA: number[] = [...Array(11).keys()];
export const CLOSE_SURVEY_TIMEOUT = 3000;

export const SURVEY_BUTTONS_WRAPPER = 'vto-survey-buttons-wrapper';
export const SURVEY_BUTTON = 'vto-survey-button';

export const FORM_DATA_FIELD = Object.freeze({
    USER_IDENTIFIER_FIELD: 'entry.1767715272',
    PAGE_FIELD: 'entry.107238290',
    VTO_TYPE_FIELD: 'entry.2017070630',
    NP_FIELD: 'entry.1596679860',
    COMMENT_FIELD: 'entry.1094555031'
});

export const GOOGLE_FORMS_URL =
    'https://docs.google.com/forms/d/e/1FAIpQLScKp12Vt-BAn53_Jkuy6xwTaTobcznksaKrxRFAuAoG2b30pA/formResponse';

export const MOCK_SURVEY_DATA: ISurveyData = {
    np: '10',
    comment: 'vto is awesome',
    userIdentifier: '1292791192',
    page:
        'https://e.esteelauder.na.us.vmicu.eng.ncsa9.elcdev.net/product/649/29657/product-catalog/makeup/lips/lipstick/pure-color-envy/sculpting-lipstick',
    vtoType: 'Makeup'
};
